import { Group, Stack } from "@mantine/core"
import type { Prisma } from "@tfg/db"

import { FiltersLogicalSection } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/FiltersForm/FiltersLogicalSection.tsx"
import { FiltersSimpleSection } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/FiltersForm/FiltersSimpleSection.tsx"

interface FiltersSectionProps {
  filters: Prisma.JsonObject
  setFilters: (filters: Prisma.JsonObject) => void
}

function isLogicalFilter(
  key: string,
  _value: unknown
): _value is Prisma.JsonArray {
  return key === "AND" || key === "OR" || key == "NOT"
}

export const FiltersSection = ({
  filters,
  setFilters,
}: FiltersSectionProps) => {
  return (
    <Stack gap="md">
      {Object.entries(filters).map(([key, value], index) => {
        return (
          <Group key={key}>
            {isLogicalFilter(key, value) ? (
              <FiltersLogicalSection
                key={key}
                logicalKey={key}
                value={value}
                filters={filters}
                setFilters={setFilters}
              />
            ) : (
              <FiltersSimpleSection
                key={index}
                filterKey={key}
                value={Object(value)}
                filters={filters}
                setFilters={setFilters}
              />
            )}
          </Group>
        )
      })}
    </Stack>
  )
}
